import styled from 'styled-components';

export const Overview = styled.div`
  padding: 16px 24px;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  background-color: #F9FAFC;
`;
